module.exports = __webpack_public_path__ + "img/code.d69d90d0.png";